import React, { useState } from 'react';
import { useAppState } from '../../context/AppStateProvider';
import { Inbox, Plus } from 'lucide-react';

const WorkspaceCapture = () => {
  const { folders, addItem, addLead } = useAppState();
  const [captureType, setCaptureType] = useState('tool');
  const [formData, setFormData] = useState({
    title: '',
    url: '',
    category: 'tools',
    folderId: '',
    businessName: '',
    niche: '',
    leadCategory: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (captureType === 'lead') {
      if (formData.businessName.trim()) {
        addLead(formData.businessName.trim(), formData.niche.trim(), formData.leadCategory.trim());
        setFormData({ ...formData, businessName: '', niche: '', leadCategory: '' });
      }
    } else {
      if (formData.title.trim() && formData.url.trim()) {
        addItem(
          formData.title.trim(),
          formData.url.trim(),
          formData.category,
          formData.folderId || null
        );
        setFormData({ ...formData, title: '', url: '', folderId: '' });
      }
    }
  };

  const categoryFolders = folders.filter(f => f.category === formData.category);

  return (
    <div className="workspace-container" data-testid="workspace-capture">
      <div className="workspace-header">
        <div className="workspace-header-left">
          <Inbox className="workspace-icon" size={24} />
          <div>
            <h2 className="workspace-title">Capture</h2>
            <p className="workspace-subtitle">Quickly add items to your command center</p>
          </div>
        </div>
      </div>

      <div className="capture-form-container">
        <div className="capture-tabs">
          <button
            className={`capture-tab ${captureType !== 'lead' ? 'capture-tab-active' : ''}`}
            data-testid="tab-item"
            onClick={() => setCaptureType('tool')}
          >
            Add Item
          </button>
          <button
            className={`capture-tab ${captureType === 'lead' ? 'capture-tab-active' : ''}`}
            data-testid="tab-lead"
            onClick={() => setCaptureType('lead')}
          >
            Add Lead
          </button>
        </div>

        <form onSubmit={handleSubmit} className="capture-form" data-testid="capture-form">
          {captureType === 'lead' ? (
            <>
              <div className="form-group">
                <label className="form-label">Business Name</label>
                <input
                  type="text"
                  value={formData.businessName}
                  onChange={(e) => setFormData({ ...formData, businessName: e.target.value })}
                  className="form-input"
                  data-testid="business-name-input"
                  placeholder="Enter business name"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Category</label>
                <input
                  type="text"
                  value={formData.leadCategory}
                  onChange={(e) => setFormData({ ...formData, leadCategory: e.target.value })}
                  className="form-input"
                  data-testid="lead-category-input"
                  placeholder="e.g., Quick Website, Full Rebrand"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Niche/Industry</label>
                <input
                  type="text"
                  value={formData.niche}
                  onChange={(e) => setFormData({ ...formData, niche: e.target.value })}
                  className="form-input"
                  data-testid="niche-input"
                  placeholder="e.g., E-commerce, SaaS, Agency"
                />
              </div>
            </>
          ) : (
            <>
              <div className="form-group">
                <label className="form-label">Category</label>
                <select
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value, folderId: '' })}
                  className="form-select"
                  data-testid="category-select"
                >
                  <option value="tools">Tools</option>
                  <option value="prompts">Prompts</option>
                  <option value="bookmarks">Bookmarks</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  className="form-input"
                  data-testid="title-input"
                  placeholder="Enter item title"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">URL</label>
                <input
                  type="url"
                  value={formData.url}
                  onChange={(e) => setFormData({ ...formData, url: e.target.value })}
                  className="form-input"
                  data-testid="url-input"
                  placeholder="https://example.com"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Folder (Optional)</label>
                <select
                  value={formData.folderId}
                  onChange={(e) => setFormData({ ...formData, folderId: e.target.value })}
                  className="form-select"
                  data-testid="folder-select"
                >
                  <option value="">No folder</option>
                  {categoryFolders.map(folder => (
                    <option key={folder.id} value={folder.id}>{folder.name}</option>
                  ))}
                </select>
              </div>
            </>
          )}
          <button type="submit" className="submit-btn" data-testid="submit-capture-btn">
            <Plus size={18} />
            {captureType === 'lead' ? 'Add Lead' : 'Add Item'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default WorkspaceCapture;
